export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '机器人管控平台',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'http://192.168.30.169:7456//api/',
    //dev: 'http://123.60.189.195/api/', // 线上
    // pro: 'http://123.60.189.195/api/'
    //pro: 'http://10.11.24.240/api/'
    //pro: 'http://10.28.25.100/api/'
    //pro: 'http://192.168.30.106/api/'
    pro: 'http://123.60.189.195/api/'
  },

  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: false, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: false // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    },
    'langPlugin': true,
    'autoTranslate': false // 控制是否自动翻译
  },
  version: '1.0.1'  // 每次打包升级服务器前手动修改这个版本号 +1
}
